import { fromJS } from 'immutable';
import { v4 as uuidv4 } from 'uuid';

export const SET_CORRELATION_ID = 'modules/axp-manage-bookings-root/SET_CORRELATION_ID';
export const initialState = fromJS({
  correlationId: uuidv4(),
});

export default function reducer(state = initialState) {
  return state;
}
